export default [
    {
        path: 'dropshipping',
        name: 'drop_shipping',
        meta: {
            access: ['AUTH_EMAIL_GROUP'],
            title: 'drop_shipping',
            icon: 'icon-guangbo',
            notPageView: true,
        },
        redirect: { name: 'drop_shipping_edm_list' },
        component: () => import(/* webpackChunkName: "marketing" */ '@/views/main/broadcast/dropshipping/index.vue'),
        children: [
            /* EDM 代发 start */
            {
                path: 'edm/list',
                name: 'drop_shipping_edm_list',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_EMAIL_GROUP'],
                    title: 'drop_shipping',
                    icon: 'icon-guangbo',
                },
                component: () => import(/* webpackChunkName: "marketing" */ '@/views/main/broadcast/dropshipping/EDM/index.vue'),
            },
            {
                path: 'edm/detail',
                name: 'drop_shipping_edm_detail',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_EMAIL_GROUP'],
                    title: 'marketing_plan_detail',
                    icon: 'icon-guangbo',
                },
                component: () => import(/* webpackChunkName: "marketing" */ '@/views/main/broadcast/dropshipping/EDM/Detail.vue'),
                children: [
                    {
                        path: 'sent/:id',
                        name: 'drop_shipping_edm_detail_sent',
                        meta: {
                            access: ['AUTH_EMAIL_GROUP'],
                            title: 'marketing_plan_sent',
                            icon: 'ios-list',
                        },
                        component: () => import(/* webpackChunkName: "marketing" */ '@/views/main/broadcast/dropshipping/EDM/SentComponent.vue'),
                    },
                ],
            },
            {
                path: 'edm/edit/:id*',
                name: 'drop_shipping_edm_edit',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_EMAIL_GROUP'],
                    title: 'drop_shipping_edm_edit',
                    icon: 'icon-guangbo',
                },
                props: (route: any) => {
                    return {
                        ...route.query,
                        ...route.params,
                    };
                },
                component: () => import(/* webpackChunkName: "marketing" */ '@/views/main/broadcast/dropshipping/EDM/edit.vue'),
            },
            /* EDM 代发 end */
        ],
    },
];
